<template>
  <el-container class="layout-root">
    <el-aside class="layout-aside" width="220px">
      <div class="brand">
        <span class="brand-mark">M</span>
        <div>
          <div class="brand-title">MiCon 管理台</div>
          <div class="brand-sub">Vue2 Admin</div>
        </div>
      </div>
      <el-menu
        :default-active="$route.path"
        background-color="#10244f"
        text-color="#b7c4e1"
        active-text-color="#ffffff"
        router
      >
        <el-menu-item index="/users">
          <i class="el-icon-user-solid" />
          <span slot="title">用户管理</span>
        </el-menu-item>
        <el-menu-item index="/products">
          <i class="el-icon-goods" />
          <span slot="title">商品管理</span>
        </el-menu-item>
        <el-menu-item index="/qualifications">
          <i class="el-icon-document-checked" />
          <span slot="title">资质管理</span>
        </el-menu-item>
        <el-menu-item index="/banners">
          <i class="el-icon-picture" />
          <span slot="title">轮播管理</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header class="layout-header">
        <div class="header-title">{{ currentTitle }}</div>
        <div class="header-right">
          <span class="admin-name">管理员：{{ adminName }}</span>
          <el-button type="text" @click="logout">退出登录</el-button>
        </div>
      </el-header>
      <el-main class="layout-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { adminMe } from '../api/admin'
import { clearToken, isAuthRedirectError } from '../utils/auth'

export default {
  name: 'AdminLayout',
  data() {
    return {
      adminName: 'admin'
    }
  },
  computed: {
    currentTitle() {
      return (this.$route.meta && this.$route.meta.title) || '\u540e\u53f0\u7ba1\u7406'
    }
  },
  created() {
    this.loadAdminInfo()
  },
  methods: {
    async loadAdminInfo() {
      try {
        const data = await adminMe()
        this.adminName = data.username || 'admin'
      } catch (error) {
        if (isAuthRedirectError(error)) {
          return
        }
        this.$message.error(error.message || '\u7ba1\u7406\u5458\u4fe1\u606f\u83b7\u53d6\u5931\u8d25')
      }
    },
    logout() {
      clearToken()
      this.$router.replace('/login')
    }
  }
}
</script>

<style scoped>
.layout-root {
  min-height: 100vh;
}

.layout-aside {
  background: linear-gradient(180deg, #10244f 0%, #0d1b3a 100%);
  color: #fff;
  overflow: hidden;
}

.brand {
  height: 72px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.brand-mark {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  background: linear-gradient(135deg, #4a9eff, #3ad0ff);
  color: #0a1f44;
}

.brand-title {
  font-size: 16px;
  font-weight: 600;
  color: #f2f6ff;
}

.brand-sub {
  margin-top: 2px;
  font-size: 12px;
  color: #98a8ca;
}

.layout-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #e9edf5;
  box-shadow: 0 2px 10px rgba(18, 35, 77, 0.04);
}

.header-title {
  font-size: 18px;
  font-weight: 600;
  color: #1d2f57;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 14px;
}

.admin-name {
  color: #5c6783;
  font-size: 13px;
}

.layout-main {
  padding: 18px;
  background: #f4f7fb;
}
</style>
